import { FC } from "react";
import { DIVIDED_STYLES, GROUP_STYLES } from "../styles";

export const GroupWrapper: FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={GROUP_STYLES}>
      <div className={DIVIDED_STYLES}>{children}</div>
    </div>
  );
};
